import { Routes } from '@angular/router';
import { authGuard, loginGuard } from './core/auth.guard';
import { ShellComponent } from './layout/shell.component';
import { unsavedRecordGuard } from './pages/record-form/record-form.component';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [loginGuard],
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'proyectos',
        loadComponent: () => import('./pages/projects/projects.component').then(m => m.ProjectsComponent)
      },
      {
        path: 'registros/nuevo',
        loadComponent: () => import('./pages/record-form/record-form.component').then(m => m.RecordFormComponent),
        canDeactivate: [unsavedRecordGuard]
      },
      {
        path: 'registros/editar/:id',
        loadComponent: () => import('./pages/record-form/record-form.component').then(m => m.RecordFormComponent),
        canDeactivate: [unsavedRecordGuard]
      },
      {
        path: 'registros',
        loadComponent: () => import('./pages/records/records.component').then(m => m.RecordsComponent)
      },
      {
        path: 'mapa',
        loadComponent: () => import('./pages/map/map.component').then(m => m.MapComponent)
      },
      {
        path: 'catalogo',
        loadComponent: () => import('./pages/catalog/catalog.component').then(m => m.CatalogComponent)
      },
      {
        path: 'catalogo/:id',
        loadComponent: () => import('./pages/catalog/catalog-detail.component').then(m => m.CatalogDetailComponent)
      },
      {
        path: 'informes',
        loadComponent: () => import('./pages/reports/reports.component').then(m => m.ReportsComponent)
      },
      {
        path: 'registros/:id',
        loadComponent: () => import('./pages/record-detail/record-detail.component').then(m => m.RecordDetailComponent)
      }
    ]
  },
  { path: '**', redirectTo: '' }
];
